import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

/* Home showreel: the motion covers stacked like a deck — each card pins and the next slides over it.
   Each video plays only while it is on screen. Sits above the existing Deck section, which stays as it is. */
const REEL = [
  { slug: 'pudeuc', name: 'Pudeuc', kind: 'Fashion brand · Art direction' },
  { slug: 'pawtimo', name: 'Pawtimo', kind: 'iOS app · Family pet care' },
  { slug: 'findbrandvoice', name: 'Find Brand Voice', kind: 'Web app · Brand voice' },
  { slug: 'prove-it', name: 'Prove It', kind: 'iOS app · Income tracker' },
  { slug: 'the-sportship', name: 'The Sportship', kind: 'Website · Sports news & stats' },
  { slug: 'onepiecequiz', name: 'One Piece Trivia', kind: 'Game site · Quizzes & jigsaw race' },
];

function ReelCard({ item, index, dark }) {
  const ref = useRef(null);
  useEffect(() => {
    const v = ref.current;
    if (!v || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) v.play().catch(() => {}); else v.pause(); }, { threshold: 0.35 });
    io.observe(v);
    return () => io.disconnect();
  }, []);
  return (
    <div className="reel-slot" style={{ top: `calc(76px + ${index * 14}px)` }}>
      <Link to={`/projects/${item.slug}`} className="reel-card" aria-label={`${item.name} — view project`}>
        <div className="reel-video"><video ref={ref} src={`/showcase/${item.slug}/cover.mp4`} poster={`/showcase/${item.slug}/poster.jpg`} muted loop playsInline preload="none" />
        <div className="reel-meta">
          <span className="reel-num">{String(index + 1).padStart(2, '0')}</span>
          <span className="reel-name">{item.name}</span>
          <span className="reel-kind">{item.kind}</span>
          <span className="reel-go">View project →</span>
        </div></div>
      </Link>
    </div>
  );
}

export default function HomeReel({ mode = 'dark' }) {
  const dark = mode === 'dark';
  return (
    <section aria-label="Work" style={{ padding: 'clamp(28px, 5vw, 56px) clamp(16px, 4vw, 40px) 0' }}>
      <style>{`
        .reel-head{width:min(1100px, calc((100svh - 120px) * 4 / 3), 100%);margin:0 auto clamp(18px,3vw,28px);display:flex;justify-content:space-between;align-items:baseline;gap:12px;flex-wrap:wrap;color:${dark ? '#f2f2f2' : '#111'}}
        .reel-head h2{margin:0;font-size:clamp(28px,5vw,56px);letter-spacing:-.04em;font-weight:700;line-height:1}
        .reel-head p{margin:0;font-size:14px;opacity:.6}
        .reel-slot{position:sticky;margin:0 auto 32vh;width:min(1100px, calc((100svh - 120px) * 4 / 3), 100%)}
        .reel-slot:last-child{margin-bottom:clamp(24px,4vw,48px)}
        .reel-card{position:relative;display:block;border-radius:clamp(16px,2vw,28px);overflow:hidden;background:#0b0b0c;
          box-shadow:0 -10px 40px rgba(0,0,0,${dark ? .55 : .18}),0 30px 80px rgba(0,0,0,${dark ? .45 : .16});text-decoration:none;color:#fff;transform:translateZ(0)}
        .reel-strip{display:block;width:100%;aspect-ratio:4/1;object-fit:cover;object-position:50% 50%;border-bottom:1px solid rgba(255,255,255,.08)}
        .reel-video{position:relative;aspect-ratio:4/3;overflow:hidden}
        .reel-card video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;transition:transform .8s cubic-bezier(.2,.7,.2,1)}
        .reel-card:hover video{transform:scale(1.015)}
        .reel-meta{position:absolute;left:0;right:0;bottom:0;display:flex;align-items:baseline;gap:12px;flex-wrap:wrap;padding:clamp(14px,2.4vw,24px) clamp(16px,2.6vw,28px);
          background:linear-gradient(0deg,rgba(0,0,0,.62) 0%,rgba(0,0,0,0) 100%)}
        .reel-num{font-size:12px;opacity:.7;font-variant-numeric:tabular-nums}
        .reel-name{font-size:clamp(18px,2.4vw,26px);font-weight:700;letter-spacing:-.02em}
        .reel-kind{font-size:13px;opacity:.75}
        .reel-go{margin-left:auto;font-size:13px;font-weight:600;padding:8px 14px;border-radius:999px;background:rgba(255,255,255,.16);backdrop-filter:blur(8px)}
        @media (max-width:640px){.reel-go{display:none}.reel-slot{margin-bottom:14vh}}
      `}</style>
      <div className="reel-head"><h2>Work</h2><p>Scroll · tap a project to open it</p></div>
      {REEL.map((item, i) => <ReelCard key={item.slug} item={item} index={i} dark={dark} />)}
    </section>
  );
}
